import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import UserAPI from '../api/UserAPI'
import { isMobile } from 'react-device-detect'
import MetricsManager from '../managers/MetricsManager'
export default class EmailSubscribeForm extends React.Component { 
	static defaultProps = {
		title: "Subscribe to stay in the know",
		body: null,
		includeCity: false
	}

	constructor(props) { 
		super(props)
		this.state = { 
			email: '',
			city: '', 
			subscribed: false
		}
		this.userApi = new UserAPI()
		this.metricsManager = new MetricsManager()
	}


	async handleSubscribe() {
		if (this.state.email === '') { 
			alert("Please enter a valid email")
			return
		}

		if (this.props.includeCity && this.state.city === '') { 
			alert("Please enter a valid city")
			return
		}

		var city = null
		if (this.state.city !== '') { 
			city = this.state.city
		}

		this.metricsManager.logEvent("email_subscribe", {city: city, listId: this.props.listId})

		const result = await this.userApi.subscribe(this.state.email, city, this.props.listId)
		console.log(result);
		if (result && result.code !== -1) { 
			this.setState({subscribed: true})
		} else { 
			alert("Sorry, we failed to subscribe. Try again later.")
		}
		if (this.props.onSubscribeFinish) { 
			this.props.onSubscribeFinish({email: this.state.email});
		}
	}

	getSubscribe() { 
		if (this.state.subscribed) { 
			return <p style={{textAlign: 'center', color: 'green', fontSize: 12}}>{this.props.postCompleteMsg ? this.props.postCompleteMsg : "Thanks for subscribing. We'll be in touch!"}</p>
		} else { 
			return <InputGroup className="mb-3"
				 style={{width: isMobile === true ? '100%' : '60%'}}>
				   <FormControl
				   	onChange={(e) => this.setState({email: e.target.value})}
				      placeholder="email..."
				      aria-label="email..."
				      aria-describedby="basic-addon2"
				    />
				    {this.props.includeCity && <FormControl 
				    	onChange={(e) => this.setState({city: e.target.value})}
				    	placeholder="city..."
				    	aria-label="city..."
				    	/>}
				   <InputGroup.Append>
				     <Button variant="outline-secondary"
				     onClick={() => this.handleSubscribe()}>Subscribe</Button>
				   </InputGroup.Append>
				 </InputGroup>
		}
	}

	render() { 
		return (
			<div>
			<p style={{textAlign: 'center', marginTop: 20, fontSize: 18, fontWeight: 'bold'}}>{this.props.title}</p>
			<p style={{textAlign: 'center', fontSize: 14}}>{this.props.body}</p>
			<div style={this.props.uncenter ? null : {display: 'flex', justifyContent: 'center'}}>
				{this.getSubscribe()}
			 </div>
			</div>
			)
	}
}